import { render, staticRenderFns } from "./worksDetail.vue?vue&type=template&id=5a709a34&"
import script from "./worksDetail.vue?vue&type=script&lang=js&"
export * from "./worksDetail.vue?vue&type=script&lang=js&"
import style0 from "./worksDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports